var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"affiliates"},[_c('AppSection',{staticClass:"hero",attrs:{"data":{
      img: { src: '/assets/video/affiliates_0.jpg' },
      video: { src: '/assets/video/affiliates_0.mp4' },
    }}},[_c('AppHeadline',{staticClass:"hero__headline",attrs:{"data":{
        content: _vm.affiliates.hero.title,
        type: 2,
      }}}),_c('span',{staticClass:"section__line hero__line"}),_c('AppParagraph',{staticClass:"hero__text",attrs:{"data":{
        content: _vm.affiliates.hero.content,
      }}})],1),_c('AppSection',{staticClass:"intro",attrs:{"data":{
      img: {
        src: _vm.affiliates.intro.img.src,
        alt: '',
      }
    }}},[_c('div',{staticClass:"intro__container"},[_c('AppHeadline',{staticClass:"intro__headline",attrs:{"data":{
          content: _vm.affiliates.intro.title,
          type: 2,
        }}}),_c('AppParagraph',{staticClass:"intro__text intro__text--margin",attrs:{"data":{
          content: _vm.affiliates.intro.content[0],
        }}}),_c('span',{staticClass:"section__line intro__line"}),_c('AppParagraph',{staticClass:"intro__text",attrs:{"data":{
          content: _vm.affiliates.intro.content[1],
        }}})],1)]),_c('AppSection',{staticClass:"first-block",attrs:{"data":{
      img: {
        src: _vm.affiliates.firstBlock.img.src,
        alt: '',
      }
    }}},[_c('AppHeadline',{staticClass:"first-block__headline",attrs:{"data":{
        content: _vm.affiliates.firstBlock.title,
        type: 2,
      }}}),_c('span',{staticClass:"section__line first-block__line"}),_c('AppParagraph',{staticClass:"first-block__text",attrs:{"data":{
        content: _vm.affiliates.firstBlock.content,
      }}})],1),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }